export type ToastTone = "neutral" | "success" | "danger" | "warning";

export interface ToastInput {
  title: string;
  body?: string;
  tone?: ToastTone;
  action?: { label: string; href?: string; onClick?: () => void };
  /** ms; 0 = sticky */
  duration?: number;
}

export interface Toast extends ToastInput {
  id: number;
}

type Listener = (toasts: Toast[]) => void;

let toasts: Toast[] = [];
let seq = 0;
const listeners = new Set<Listener>();

function emit() {
  for (const l of listeners) l(toasts);
}

export function toast(input: ToastInput): number {
  const id = ++seq;
  toasts = [...toasts.slice(-4), { ...input, id }];
  emit();
  const duration = input.duration ?? (input.tone === "danger" ? 7000 : 4500);
  if (duration > 0) setTimeout(() => dismissToast(id), duration);
  return id;
}

export function dismissToast(id: number): void {
  toasts = toasts.filter((t) => t.id !== id);
  emit();
}

export function subscribeToasts(l: Listener): () => void {
  listeners.add(l);
  l(toasts);
  return () => {
    listeners.delete(l);
  };
}
